import React from 'react';
import PropTypes from 'prop-types';
import './OrderTotal.scss';

const OrderTotal = ({ title, total }) => (
  <div className="order-total">
    <h5 className="text-mega bold order-total__title">{title}</h5>
    <h5 className="text-mega bold color-green order-total__price">{total}</h5>
  </div>
);

OrderTotal.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.string.isRequired,
};

export default OrderTotal;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderDetails/OrderTotal/OrderTotal.js